import { useEffect, useState } from "react";
import { message } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { StyledModal } from "components/App/styled";

import Button from "components/buttons/Button";
import OrderDetails from "components/Modals/AdminManageOrder/OrderDetails";
import Fetch from "components/Fetch";
import colors from "constants/palette";

// states:::
// 0 submited - processing
// 1 processed - sent via post
// 2 done
// 3 returned
// 4 cancelled

export default function CheckDetailsButton({ data, reload }) {
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    console.log("====================================");
    console.log(data);
    console.log("====================================");
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);
  useEffect(() => {
    Fetch.get(`/user/${data.user}`, (res) => {
      if (res?.[0]?.id) {
        setUser(res?.[0]);
      } else {
        message.error("خطایی رخ داده است");
      }
    });
  }, [data]);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleReturnConfirm = (state) => {
    let confirm = window.confirm(
      "از ثبت این سفارش به عنوان مرجوعی اطمینان دارید؟"
    );
    if (!confirm) return false;

    Fetch.put(`/orders/${data.id}`, { status: 3 }, (res) => {
      console.log("%c finish product response", "background: blue;", res);
      if (res) {
        message.success("با موفقیت انجام شد");
      } else {
        message.error("خطایی رخ داده است");
      }
      setVisible(false);

      reload(true);
    });
  };

  return (
    <>
      <Button style={{ marginRight: 6 }} onClick={showModal}>
        <InfoCircleOutlined />
      </Button>
      <StyledModal
        title={"جزئیات سفارش"}
        visible={visible}
        cancelText={"لغو"}
        onCancel={handleCancel}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        style={{
          direction: "rtl",
          minWidth: 300,
          maxWidth: 980,
          margin: "auto",
          background: colors.white,
          top: 20,
        }}
      >
        <OrderDetails user={user} data={data} />
        {data?.status === 2 ? (
          <Button onClick={handleReturnConfirm}>مرجوع کردن سفارش</Button>
        ) : null}
      </StyledModal>
    </>
  );
}
